import { render, staticRenderFns } from "./AdminTheming.vue?vue&type=template&id=4d6a2a5b&scoped=true"
import script from "./AdminTheming.vue?vue&type=script&lang=js"
export * from "./AdminTheming.vue?vue&type=script&lang=js"
import style0 from "./AdminTheming.vue?vue&type=style&index=0&id=4d6a2a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a2a5b",
  null
  
)

export default component.exports